export function optimizeImageUrl(url, { width, quality } = {}) {
  if (!url) return "";

  if (url.includes("res.cloudinary.com") && url.includes("/upload/")) {
    const transforms = ["f_auto", "q_auto"];

    if (width) transforms.push(`c_limit,w_${width}`);
    if (quality && quality !== "auto") transforms.push(`q_${quality}`);

    return url.replace("/upload/", `/upload/${transforms.join(",")}/`);
  }

  if (url.includes("images.unsplash.com")) {
    try {
      const parsed = new URL(url);
      parsed.searchParams.set("auto", "format");
      parsed.searchParams.set("fit", "max");
      parsed.searchParams.set("q", quality || "80");
      if (width) parsed.searchParams.set("w", String(width));
      return parsed.toString();
    } catch {
      return url;
    }
  }

  return url;
}
